// extracted by mini-css-extract-plugin
export default {"open-button":"OpenAppButton_open-button__4mGAD","arrow-container":"OpenAppButton_arrow-container__efRKJ","title":"OpenAppButton_title__bZCvH","arrow":"OpenAppButton_arrow__V+8li"};